import { Icon, Spinner, SpinnerSize, TooltipHost } from "@fluentui/react"
import styles from "./FileIcon.module.css";
import mime from "mime";

const getFileIcon = (fileType: string) => {
    // ファイルタイプに応じてアイコンを返す関数
    if (fileType.startsWith('image/')) return '🖼️';
    if (fileType.startsWith('video/')) return '🎥';
    if (fileType === 'application/pdf') return '📑';
    return '📄';
};

const getFileIconFromFileName = (fileName: string) => {
    return getFileIcon(mime.getType(fileName) ?? "")
}

interface FileIconProps {
    contentType?: string
    name: string
    backgroundColor?: string
    isLoading?: boolean
    onRemoveFile?: () => void
    onClick?: () => Promise<void>
    testId?: string
}

export const FileIcon = (props: FileIconProps) => {
    const {contentType, name, backgroundColor, isLoading, onRemoveFile, onClick, testId} = props;
    return <TooltipHost
        content={name}
        >
        <div className={styles.fileInfoContainer}>
            <div 
                className={styles.fileInfo} 
                data-testid={testId}
                style={{backgroundColor: backgroundColor ?? "#e6e6e673", cursor: onClick ? "pointer" : "auto"}} 
                onClick={onClick ? async () => {
                    await onClick()
                } : undefined}
                >
                <span className={styles.fileIcon}>{contentType ? getFileIcon(contentType) : getFileIconFromFileName(name)}</span>
                <div className={styles.fileDetails}>
                    <span className={styles.fileName}>{name}</span>
                    {contentType && <span className={styles.fileType}>{contentType}</span>}
                </div>
                {
                    onRemoveFile && <button onClick={(e) => {
                        e.stopPropagation();
                        onRemoveFile();
                    }} className={styles.removeButton} type="button" data-testid={testId && `${testId}-remove`}>
                        <Icon iconName="Cancel" />
                    </button>
                }
                {
                    isLoading && <div className={styles.loadingOverlay}>
                        <Spinner size={SpinnerSize.small} />
                    </div>
                }
            </div>
        </div>
    </TooltipHost>
}